var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Duplication d'un menu",
        "ok-title": "Dupliquer",
        "ok-disabled": _vm.duplicationEnCours || !_vm.estValide,
        "cancel-title": "Annuler",
        "no-close-on-backdrop": ""
      },
      on: {
        show: function($event) {
          return _vm.init()
        },
        ok: function($event) {
          return _vm.dupliquer()
        }
      },
      model: {
        value: _vm.afficherDuplication,
        callback: function($$v) {
          _vm.afficherDuplication = $$v
        },
        expression: "afficherDuplication"
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { key: _vm.key }, [
          _c("h4", [_c("b", [_vm._v("Menu d'origine")])]),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("MultiSelect", {
                staticStyle: { width: "100%" },
                attrs: {
                  value: [_vm.planMenuOrigineId],
                  items: _vm.tousLesPlansSource,
                  itemText: "nom",
                  itemValue: "id",
                  clearable: false,
                  multiple: false
                },
                on: {
                  change: function($event) {
                    _vm.planMenuOrigineId = $event[0]
                    _vm.checkValide()
                  }
                }
              }),
              !_vm.$v.planMenuOrigineId.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("v-date-picker", {
                staticClass: "date-picker",
                attrs: {
                  "is-range": "",
                  columns: 2,
                  step: 1,
                  popover: { visibility: "click" }
                },
                on: {
                  input: function($event) {
                    return _vm.changerPeriodeOrigine($event.start, $event.end)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var inputValue = ref.inputValue
                      var inputEvents = ref.inputEvents
                      return [
                        _c(
                          "input",
                          _vm._g(
                            {
                              domProps: {
                                value:
                                  inputValue.start || inputValue.end
                                    ? inputValue.start + " au " + inputValue.end
                                    : "Sélectionnez une période"
                              }
                            },
                            inputEvents.start
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.periodeOrigineSelectionnee,
                  callback: function($$v) {
                    _vm.periodeOrigineSelectionnee = $$v
                  },
                  expression: "periodeOrigineSelectionnee"
                }
              })
            ],
            1
          ),
          _c("h4", { staticClass: "mt-2" }, [_c("b", [_vm._v("Destination")])]),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("v-date-picker", {
                staticClass: "date-picker",
                attrs: {
                  columns: 1,
                  step: 1,
                  popover: { visibility: "click" }
                },
                on: { input: _vm.changerDebutDestination },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var inputValue = ref.inputValue
                      var inputEvents = ref.inputEvents
                      return [
                        _c(
                          "input",
                          _vm._g(
                            {
                              domProps: {
                                value: inputValue
                                  ? inputValue +
                                    " au " +
                                    _vm.dimancheDeLaSemaineDestination
                                  : "Choisir une date"
                              }
                            },
                            inputEvents
                          )
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.lundiDeLaSemaineDestination,
                  callback: function($$v) {
                    _vm.lundiDeLaSemaineDestination = $$v
                  },
                  expression: "lundiDeLaSemaineDestination"
                }
              }),
              !_vm.$v.lundiDeLaSemaineDestination.required
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Ce champ est requis")
                  ])
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card form-group" }, [
            _c("div", { staticClass: "card-body pb-0" }, [
              _vm.multiEtablissements
                ? _c(
                    "div",
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "submit",
                            title: "Ajouter une destination",
                            disabled: !_vm.estValide
                          },
                          on: {
                            click: function($event) {
                              return _vm.ajouterDestination()
                            }
                          }
                        },
                        [_vm._v("Ajouter une destination")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.multiEtablissements
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { attrs: { for: "selPlanMenuDestination" } },
                          [_vm._v("Structure de menu")]
                        ),
                        _c("MultiSelect", {
                          attrs: {
                            id: "selPlanMenuDestination",
                            value: _vm.destinations[0].planMenuDestinationIds,
                            items: _vm.destinations[0].options || [],
                            itemText: "nom",
                            itemValue: "id",
                            placeholder: "Structures de menus...",
                            emptyText: "Toutes les structures ont été ajoutées"
                          },
                          on: {
                            change: function($event) {
                              return _vm.changerPlansDestination(
                                _vm.destinations[0],
                                $event
                              )
                            }
                          }
                        }),
                        !_vm.destinations[0].plansValides
                          ? _c("div", { staticClass: "error" }, [
                              _vm._v("Ce champ est requis")
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.menuSurPlanAlimentaire
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "selPlanAlimDestination" } },
                                [_vm._v("Plan alimentaire de destination")]
                              ),
                              _c("v-select", {
                                attrs: {
                                  id: "selPlanAlimDestination",
                                  placeholder:
                                    "Plan alimentaire de destination...",
                                  options: _vm.optionsPlansAlimentaires,
                                  label: "nom",
                                  reduce: function(pa) {
                                    return pa.id
                                  }
                                },
                                model: {
                                  value: _vm.destinations[0].planAlimentaireId,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.destinations[0],
                                      "planAlimentaireId",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "destinations[0].planAlimentaireId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.destinations[0].planAlimentaireId
                            ? _c("div", { staticClass: "form-group" }, [
                                _c("a", {
                                  staticClass: "fas fa-exclamation-triangle"
                                }),
                                _vm._v(
                                  " Les menus seront dupliqués sur la période complète du plan alimentaire à partir de la date de destination "
                                )
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    _vm._l(_vm.destinations, function(destination, iDest) {
                      return _c("div", { key: iDest }, [
                        iDest > 0
                          ? _c("hr", { staticClass: "mt-0" })
                          : _vm._e(),
                        _vm.destinations.length > 1
                          ? _c(
                              "div",
                              { staticClass: "mt-2 flex-end" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn btn-danger",
                                    attrs: {
                                      title: "Supprimer cette destination"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.supprimerDestination(iDest)
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "selEtabDestination" + iDest } },
                              [_vm._v("Etablissement de destination")]
                            ),
                            _c("v-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "selEtabDestination" + iDest,
                                clearable: false,
                                placeholder: "Etablissement de destination...",
                                options: _vm.optionsEtablissement
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changerEtablissementDestination(
                                    destination
                                  )
                                }
                              },
                              model: {
                                value: destination.etablissementDestinationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    destination,
                                    "etablissementDestinationId",
                                    $$v
                                  )
                                },
                                expression:
                                  "destination.etablissementDestinationId"
                              }
                            }),
                            !destination.etabValide
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v("Ce champ est requis")
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                attrs: { for: "selPlanMenuDestination" + iDest }
                              },
                              [_vm._v("Structure(s) de menus")]
                            ),
                            _c("MultiSelect", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "selPlanMenuDestination" + iDest,
                                value: destination.planMenuDestinationIds,
                                items: destination.options || [],
                                itemText: "nom",
                                itemValue: "id",
                                placeholder: "Structures de menus...",
                                emptyText:
                                  "Toutes les structures ont été ajoutées"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.changerPlansDestination(
                                    destination,
                                    $event
                                  )
                                }
                              }
                            }),
                            !destination.plansValides
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v("Ce champ est requis")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
            ])
          ]),
          _c("div", { staticClass: "col-12 push-top-1rem" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col col-2" },
                [
                  _c("ToggleButton", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content:
                            "Attention, action irréversible qui supprimera tout menu présent sur la(les) destinations."
                        },
                        expression:
                          "{ content: 'Attention, action irréversible qui supprimera tout menu présent sur la(les) destinations.'}"
                      }
                    ],
                    key: _vm.ecraserMenuDestination,
                    staticStyle: {
                      "margin-bottom": "0",
                      "margin-left": "10px"
                    },
                    attrs: {
                      name: "ecraserMenuDestination",
                      id: "ecraserMenuDestination",
                      height: 21,
                      width: 60,
                      labels: { checked: "Oui", unchecked: "Non" },
                      color: { checked: "#ea0000de", unchecked: "#cccccc" }
                    },
                    on: {
                      input: function($event) {
                        _vm.hasMods = true
                      }
                    },
                    model: {
                      value: _vm.ecraserMenuDestination,
                      callback: function($$v) {
                        _vm.ecraserMenuDestination = $$v
                      },
                      expression: "ecraserMenuDestination"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col col-10" }, [
                _c("label", { attrs: { for: "ecraserMenuDestination" } }, [
                  _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                  _vm._v(" Écraser le(s) menu(s) de destination présent(s).")
                ])
              ])
            ]),
            this.multiEtablissements
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-2" },
                    [
                      _c("ToggleButton", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: {
                              content:
                                "Attention, action irréversible qui remplacera toutes les recettes validées présentes sur la(les) destinations."
                            },
                            expression:
                              "{ content: 'Attention, action irréversible qui remplacera toutes les recettes validées présentes sur la(les) destinations.'}"
                          }
                        ],
                        key: _vm.ecraserRecetteDestination,
                        staticStyle: {
                          "margin-bottom": "0",
                          "margin-left": "10px"
                        },
                        attrs: {
                          name: "ecraserRecetteDestination",
                          id: "ecraserRecetteDestination",
                          height: 21,
                          width: 60,
                          labels: { checked: "Oui", unchecked: "Non" },
                          color: { checked: "#ea0000de", unchecked: "#cccccc" }
                        },
                        on: {
                          input: function($event) {
                            _vm.hasMods = true
                          }
                        },
                        model: {
                          value: _vm.ecraserRecetteDestination,
                          callback: function($$v) {
                            _vm.ecraserRecetteDestination = $$v
                          },
                          expression: "ecraserRecetteDestination"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col col-10" }, [
                    _c(
                      "label",
                      { attrs: { for: "ecraserRecetteDestination" } },
                      [
                        _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                        _vm._v(
                          " Prendre en compte les modifications de recettes."
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }